<template>
    <div>
        <div>
            <v-skeleton-loader
                v-if="!events"
                class="mx-auto"
                type="list-item-avatar-three-line"
            ></v-skeleton-loader>
        </div>
        <v-list-item v-for="feedback in events" :key="feedback.id">
            <v-list-item-avatar class="align-self-start mt-3" size="64">
                <v-img :src="feedback.user.profile_photo_url" size="64"></v-img>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title class="soli-grey">{{
                    `${feedback.user.name}${relation(feedback)}`
                }}</v-list-item-title>
                <v-list-item-subtitle>{{
                    `${globalMomentFullDateAtTimeShort(
                        feedback.starts_at
                    )} with ${feedback.teacher.name}`
                }}</v-list-item-subtitle>
                <v-list-item-subtitle>
                    <v-icon
                        class="soli-grey soli-blue-text"
                        v-for="i in [1, 2, 3, 4, 5]"
                        :key="i"
                    >
                        {{ feedback.rating >= i ? "star" : "star_outline" }}
                    </v-icon>
                </v-list-item-subtitle>
                <v-list-item-subtitle
                    class="soli-grey"
                    style="white-space: normal"
                >
                    {{ feedback.comment }}
                </v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>

        <!--<SoliForm 
            v-if="showDetails" 
            :title="`Assessment with ${showDetails.lesson.teacher.name}`"
            :subtitle="getDetails"
            hideBtn
            lessonDetails
            cardBody
            @reset="showDetails = null"
        >
            <template #body>
                <v-list three-line>
                <v-list-item v-for="feedback in events.filter(e => e.lesson.id == showDetails.lesson.id)" :key="feedback.id">
                    <v-list-item-avatar>
                        <v-img :src="feedback.user.profile_photo_url"></v-img>
                    </v-list-item-avatar>
                    <v-list-item-content>
                        <v-list-item-title class="soli-grey">{{ feedback.user.name }}</v-list-item-title>
                        <v-list-item-subtitle>
                        <v-icon class="soli-grey" v-for="i in [1,2,3,4,5]" :key="i">
                            {{ feedback.rating == i ? 'star' : 'star_outline' }}
                        </v-icon>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle class="soli-grey" style="white-space: normal"> {{ feedback.comment }} </v-list-item-subtitle>
                    </v-list-item-content>
                </v-list-item>
                </v-list>
            </template>
        </SoliForm>-->
    </div>
</template>

<script>
import globalMoment from "../../Mixins/GlobalMoment.js";

export default {
    mixins: [globalMoment],
    props: ["events"],
    components: {},
    data: function () {
        return {
            //showDetails: null
        };
    },
    methods: {
        relation(feedback) {
            let relation = feedback.relationships.find((relationship) =>
                feedback.studentIds.map((e) => e.id).includes(relationship.id)
            );

            if (!relation) return " (Student)";
            return ` (${relation.pivot.relation})`;
        },
    },
    computed: {
        /*getDetails(){
            return this.showDetails
                ? [
                      {
                          icon: "storefront",
                          text: `Musicologie ${this.showDetails.lesson.room.location.name}`,
                      },
                      {
                          icon: "schedule",
                          text: `${moment(this.showDetails.lesson.starts_at).format(
                              "h:mma"
                          )} to ${moment(this.showDetails.lesson.ends_at).format("h:mma")} ${
                              this.$page.props.auth.user.timezone !==
                              "America/New_York"
                                  ? moment()
                                        .tz(this.$page.props.auth.user.timezone)
                                        .format("z")
                                  : ""
                          }`,
                      },
                      {
                          icon: "today",
                          text: moment(this.showDetails.lesson.starts_at).format("ll"),
                      },
                      {
                          icon: "meeting_room",
                          text: this.showDetails.lesson.room.title,
                      },
                  ]
                : null;
        },*/
    },
};
</script>
